module.exports = __webpack_public_path__ + "static/fish.bafd516a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish.jpg
// module id = 346
// module chunks = 35783957827783